import { HttpInterceptor } from '../../auth/HttpInterceptor';
class NewFeedsServices {
    async setSignedUrl(data) {
        const response = await HttpInterceptor.post(process.env.REACT_APP_FEEDAPI_URL+'gets3signedassetsurl',data);
        return response.data;
    }

}

export default new NewFeedsServices();